export default "/images/vendor/flag-icon-css/flags/4x3/cx.svg?b9b5e6cd65826aab60c67ecc613a4612";